<template>
  <nav>
    <div class="menu-items-container">
      <FigureEyes />
      <ul>
        <li>
          <button @click="$emit('closeMenu')">
            <router-link to="/">
              <span class="menu-item-icon home-icon">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 23 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.1079 10.3292L12.0518 0.280376C11.9793 0.207827 11.8933 0.15027 11.7987 0.110999C11.704 0.0717277 11.6025 0.0515137 11.5 0.0515137C11.3975 0.0515137 11.296 0.0717277 11.2013 0.110999C11.1067 0.15027 11.0206 0.207827 10.9482 0.280376L0.89209 10.3292C0.599121 10.6222 0.433105 11.0201 0.433105 11.4352C0.433105 12.297 1.13379 12.9977 1.99561 12.9977H3.05518V20.1681C3.05518 20.6002 3.4043 20.9493 3.83643 20.9493H9.9375V15.4806H12.6719V20.9493H19.1636C19.5957 20.9493 19.9448 20.6002 19.9448 20.1681V12.9977H21.0044C21.4194 12.9977 21.8174 12.8341 22.1103 12.5387C22.7183 11.9283 22.7183 10.9396 22.1079 10.3292V10.3292Z"
                    fill="#4F4E4E"
                  />
                </svg>
              </span>
              ГЛАВНАЯ</router-link
            >
          </button>
        </li>
        <li>
          <button @click="$emit('closeMenu')">
            <router-link to="/rules">
              <span class="menu-item-icon rules-icon">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 17 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 2.5V17.5C0 18.163 0.263392 18.7989 0.732233 19.2678C1.20107 19.7366 1.83696 20 2.5 20H15.75C15.9489 20 16.1397 19.921 16.2803 19.7803C16.421 19.6397 16.5 19.4489 16.5 19.25C16.5 19.0511 16.421 18.8603 16.2803 18.7197C16.1397 18.579 15.9489 18.5 15.75 18.5H2.5C2.23478 18.5 1.98043 18.3946 1.79289 18.2071C1.60536 18.0196 1.5 17.7652 1.5 17.5H15.75C15.9489 17.5 16.1397 17.421 16.2803 17.2803C16.421 17.1397 16.5 16.9489 16.5 16.75V2.5C16.5 2.1717 16.4353 1.84661 16.3097 1.54329C16.1841 1.23998 15.9999 0.964379 15.7678 0.732233C15.5356 0.500087 15.26 0.315938 14.9567 0.190301C14.6534 0.0646644 14.3283 0 14 0H2.5C1.83696 0 1.20107 0.263392 0.732233 0.732233C0.263392 1.20107 0 1.83696 0 2.5ZM7 6.018C6.9953 6.21378 6.91421 6.39995 6.77407 6.53673C6.63392 6.67351 6.44583 6.75006 6.25 6.75C5.5 6.75 5.5 5.999 5.5 5.999V5.99C5.50053 5.94523 5.5032 5.90051 5.508 5.856C5.55224 5.46971 5.69706 5.10179 5.928 4.789C6.382 4.176 7.198 3.727 8.513 3.75C9.463 3.767 10.306 4.165 10.834 4.82C11.371 5.487 11.552 6.39 11.196 7.279C10.834 8.184 10.015 8.544 9.544 8.75L9.494 8.773C9.214 8.896 9.081 8.96 9.001 9.024L9 9.025V9.749C9.00013 9.94791 8.92124 10.1387 8.78068 10.2795C8.64013 10.4202 8.44941 10.4994 8.2505 10.4995C8.05159 10.4996 7.86077 10.4207 7.72002 10.2802C7.57928 10.1396 7.50013 9.94891 7.5 9.75V9C7.5 8.477 7.752 8.103 8.063 7.853C8.313 7.653 8.628 7.515 8.849 7.417L8.887 7.4C9.429 7.161 9.687 7.013 9.804 6.721C9.87268 6.56401 9.89616 6.39095 9.87178 6.22134C9.84739 6.05172 9.77612 5.89229 9.666 5.761C9.444 5.486 9.037 5.259 8.487 5.25C7.552 5.234 7.242 5.535 7.134 5.682C7.06248 5.77908 7.01641 5.89254 7 6.012V6.018ZM9.25 12.5C9.25 12.7652 9.14464 13.0196 8.95711 13.2071C8.76957 13.3946 8.51522 13.5 8.25 13.5C7.98478 13.5 7.73043 13.3946 7.54289 13.2071C7.35536 13.0196 7.25 12.7652 7.25 12.5C7.25 12.2348 7.35536 11.9804 7.54289 11.7929C7.73043 11.6054 7.98478 11.5 8.25 11.5C8.51522 11.5 8.76957 11.6054 8.95711 11.7929C9.14464 11.9804 9.25 12.2348 9.25 12.5Z"
                    fill="#4F4E4E"
                  />
                </svg>
              </span>
              ПРАВИЛА</router-link
            >
          </button>
        </li>
        <li>
          <button @click="$emit('closeMenu')">
            <router-link to="/settings">
              <span class="menu-item-icon settings-icon">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.82 20H8.18001C7.95194 20 7.73071 19.9221 7.55301 19.7792C7.37531 19.6362 7.25181 19.4368 7.20301 19.214L6.79601 17.33C6.25306 17.0921 5.73824 16.7946 5.26101 16.443L3.42401 17.028C3.20657 17.0973 2.97196 17.0902 2.75913 17.0078C2.5463 16.9254 2.36806 16.7727 2.25401 16.575L0.430006 13.424C0.317152 13.2261 0.274789 12.9958 0.309849 12.7708C0.344909 12.5457 0.455315 12.3392 0.623006 12.185L2.04801 10.885C1.9832 10.2961 1.9832 9.70189 2.04801 9.113L0.623006 7.816C0.455078 7.66177 0.344521 7.45507 0.309455 7.22978C0.27439 7.00449 0.316896 6.77397 0.430006 6.576L2.25001 3.423C2.36406 3.22532 2.5423 3.07259 2.75513 2.99019C2.96796 2.90778 3.20257 2.90066 3.42001 2.97L5.25701 3.555C5.50101 3.375 5.75501 3.207 6.01701 3.055C6.27001 2.913 6.53001 2.784 6.79601 2.669L7.20401 0.787C7.25258 0.564198 7.37584 0.364688 7.55335 0.221549C7.73087 0.0784098 7.95197 0.000239966 8.18001 0H11.82C12.048 0.000239966 12.2691 0.0784098 12.4467 0.221549C12.6242 0.364688 12.7474 0.564198 12.796 0.787L13.208 2.67C13.7503 2.90927 14.2649 3.20668 14.743 3.557L16.581 2.972C16.7983 2.90292 17.0327 2.91017 17.2453 2.99256C17.4579 3.07495 17.636 3.22753 17.75 3.425L19.57 6.578C19.802 6.985 19.722 7.5 19.377 7.817L17.952 9.117C18.0168 9.70589 18.0168 10.3001 17.952 10.889L19.377 12.189C19.722 12.507 19.802 13.021 19.57 13.428L17.75 16.581C17.636 16.7787 17.4577 16.9314 17.2449 17.0138C17.0321 17.0962 16.7974 17.1033 16.58 17.034L14.743 16.449C14.2661 16.8003 13.7516 17.0975 13.209 17.335L12.796 19.214C12.7472 19.4366 12.6239 19.6359 12.4464 19.7788C12.2689 19.9218 12.0479 19.9998 11.82 20ZM9.99601 6C8.93514 6 7.91772 6.42143 7.16758 7.17157C6.41743 7.92172 5.99601 8.93913 5.99601 10C5.99601 11.0609 6.41743 12.0783 7.16758 12.8284C7.91772 13.5786 8.93514 14 9.99601 14C11.0569 14 12.0743 13.5786 12.8244 12.8284C13.5746 12.0783 13.996 11.0609 13.996 10C13.996 8.93913 13.5746 7.92172 12.8244 7.17157C12.0743 6.42143 11.0569 6 9.99601 6Z"
                    fill="#4F4E4E"
                  />
                </svg>
              </span>
              НАСТРОЙКИ</router-link
            >
          </button>
        </li>
        <li>
          <button @click="shareApp">
            <span class="menu-item-icon share-icon">
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.49998 13C5.37463 12.9974 6.2162 12.6653 6.85698 12.07L13.117 15.647C12.9072 16.4666 12.9997 17.3343 13.3774 18.0913C13.7552 18.8483 14.3929 19.4439 15.1739 19.7692C15.9549 20.0944 16.827 20.1274 17.6304 19.8623C18.4337 19.5971 19.1147 19.0515 19.5487 18.3252C19.9827 17.599 20.1406 16.7408 19.9935 15.9076C19.8464 15.0745 19.4041 14.3222 18.7477 13.7885C18.0913 13.2548 17.2646 12.9753 16.419 13.0013C15.5734 13.0273 14.7654 13.357 14.143 13.93L7.88298 10.353C7.94898 10.103 7.98498 9.84396 7.99098 9.58496L14.141 6.06996C14.7332 6.60874 15.4926 6.92747 16.2919 6.97268C17.0912 7.01789 17.8818 6.78684 18.5309 6.31828C19.1801 5.84972 19.6484 5.17217 19.8572 4.39929C20.066 3.6264 20.0027 2.80522 19.6778 2.0735C19.3529 1.34178 18.7863 0.744037 18.073 0.38056C17.3597 0.0170831 16.543 -0.0900175 15.7601 0.077226C14.9772 0.244469 14.2756 0.675882 13.773 1.29909C13.2705 1.92229 12.9975 2.69937 13 3.49996C13.004 3.78796 13.043 4.07497 13.117 4.35296L7.43297 7.59997C7.10335 7.09003 6.64674 6.67461 6.10799 6.39454C5.56925 6.11446 4.96691 5.97936 4.36015 6.00251C3.7534 6.02566 3.1631 6.20627 2.64726 6.52658C2.13142 6.84689 1.70779 7.29589 1.41798 7.82946C1.12817 8.36303 0.982159 8.96282 0.99429 9.56989C1.00642 10.177 1.17628 10.7704 1.48717 11.292C1.79806 11.8136 2.2393 12.2453 2.76752 12.5447C3.29574 12.8442 3.89278 13.0011 4.49998 13Z"
                  fill="#4F4E4E"
                />
              </svg>
            </span>
            ПОДЕЛИТЬСЯ
          </button>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import FigureEyes from './figures/FigureEyes.vue'

  // Props y Emits
  const emit = defineEmits(['closeMenu'])

  // Estado reactivo
  const navigatorInstance = ref(null)
  const urlToShare = ref(null)

  // Métodos
  const shareApp = async () => {
    try {
      if (navigatorInstance.value && navigatorInstance.value.share) {
        await navigatorInstance.value.share({
          title: 'Spyfall',
          text: 'The game where you can feel like a real detective or a cunning spy',
          url: urlToShare.value
        })

        emit('closeMenu')
      } else {
        // Fallback para navegadores que no soportan Web Share API
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(urlToShare.value)
          alert('URL copied to clipboard!')
        } else {
          console.warn('Web Share API and Clipboard API not supported')
        }
        emit('closeMenu')
      }
    } catch (error) {
      console.error('Error sharing:', error)
      emit('closeMenu')
    }
  }

  // Lifecycle
  onMounted(() => {
    navigatorInstance.value = navigator
    urlToShare.value = location.href
  })
</script>

<style scoped>
  nav {
    display: grid;
    background-color: var(--white-color);
    width: 100%;
    max-width: 450px;
    height: calc(100vh - 100px);
    place-content: center;
    position: absolute;
    left: 0;
    top: 90px;
    z-index: 1;
  }
  nav .menu-items-container {
    min-width: 80%;
    width: 300px;
    height: 300px;
    display: grid;
    place-items: center;
  }
  nav .menu-items-container ul {
    list-style: none;
    text-align: center;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
  }
  nav .menu-items-container ul li {
    margin: 6px 0;
    display: flex;
    justify-content: center;
  }
  nav .menu-items-container ul li:nth-child(2) {
    margin-bottom: 68px;
  }
  nav .menu-items-container ul li button,
  nav .menu-items-container ul li a {
    background-color: rgba(0, 0, 0, 0);
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: 1.8rem;
    line-height: 2.6rem;
    color: var(--dark-gray);
  }
</style>
